import { buildModalRoute } from '@manager/modules/modals/routable/modal-routable-utils';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';

export const routesTenant: RouteMetaConfig[] = [
  {
    path: '/tenants',
    name: routeNames.tenantsOverview,
    component: () => import('./TenantListView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'tenants.view',
    },
    children: [
      buildModalRoute(
        {
          name: routeNames.tenantCreate,
          path: 'create',
          meta: {
            requiresAuth: true,
            permission: 'tenants.create',
          },
          component: () => import('./TenantCreateView.vue'),
        },
        { fullscreen: true }
      ),
    ],
  },
  {
    path: '/tenants/:id(\\d+)',
    name: routeNames.tenantDetails,
    component: () => import('./TenantDetailView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'tenants.view',
    },
    children: [
      buildModalRoute(
        {
          path: 'edit/general',
          name: routeNames.tenantEditGeneral,
          meta: {
            requiresAuth: true,
            permission: 'tenants.update',
          },
          component: () => import('./TenantEditGeneralForm.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'data-import',
          name: routeNames.tenantCreateDataImport,
          meta: {
            requiresAuth: true,
            permission: 'tenant_data_imports.create_or_update',
          },
          component: () => import('./TenantDataImportView.vue'),
        },
        { fullscreen: false, width: 'xl' }
      ),
    ],
  },
];
